import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store/rootReducer'
import { ContributionType } from '../../../store/contributions/contributionsTypings'
import { setPageToReturnFromPayment, switchMenu } from '../../../store/common/commonSlice'
import './ImageConribution.sass'

import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths from '../../../paths'

import { useTranslation } from 'react-i18next'
import { isUserPro } from '../../../utils/isUserPro'
import useProtectImages from '../../../hooks/useProtectImages'

interface Props {
    item: {
        url: string
        thumbnail_url: string
        alt?: string
    }
}

const ImageContribution: React.FunctionComponent<Props> = ({ item }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation()
    useProtectImages(null)

    const { user } = useSelector((state: RootState) => state.member)
    const { member_type } = user || { member_type: undefined }
    const contribution = useSelector<RootState, ContributionType>((state) => state.contributions.contribution)
    const { pro } = contribution

    const isUserNotActive = () => user && user.active === 0

    return (
        <>
            {pro == 0 ? (
                <img src={item.url} alt={item.alt ? item.alt : ''} />
            ) : isUserPro(member_type) || (user && user.id == contribution.user.id) ? (
                <img src={item.url} alt="" />
            ) : (
                <div className="membershipRequestPhoto">
                    <img className="photo_blur" src={item.thumbnail_url} alt="" />
                    <div className="blur">.</div>
                    <div className="content-no-xxl-member">
                        {!user && <p>{t(`Please log in to view this photo`)}</p>}
                        {user && !isUserNotActive() && <p>{t(`Become a member to view this photo`)}</p>}
                        {user && isUserNotActive() && <p>{t(`Activate your account to view this photo`)}</p>}
                        {user ? (
                            <button
                                className="login-button"
                                onClick={() => {
                                    if (isUserNotActive()) {
                                        history.push(location.pathname + '?activate')
                                    } else {
                                        history.push(createLocalizedPath(paths.payment.path))
                                        dispatch(setPageToReturnFromPayment(location.pathname))
                                    }
                                }}
                            >
                                {isUserNotActive() ? t('Activate') : t(`Become an XXL member`)}
                            </button>
                        ) : (
                            <button
                                className="login-button"
                                onClick={() => {
                                    dispatch(switchMenu())
                                }}
                            >
                                {t(`Log in`)}
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default ImageContribution
